<template>
  <v-app>
    <navigation :color="color" :flat="flat" />
    <v-main class="pt-56">
      <home />
      <blog-section />
      <about />
      <comments-section />
      <pricing />
    </v-main>
    <v-scale-transition>
      <v-btn
        fab
        v-show="fab"
        v-scroll="onScroll"
        dark
        fixed
        bottom
        right
        color="secondary"
        @click="toTop"
      >
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </v-scale-transition>
    <app-footer />
  </v-app>
</template>


<script>
import navigation from '@/components/Navigation'
import AppFooter from '@/components/Footer'
import home from '@/components/HomeSection'
import about from '@/components/AboutSection'
import pricing from '@/components/PricingSection'
import contact from '@/components/ContactSection'
import BlogSection from '@/components/BlogSection'
import CommentsSection from '@/components/CommentsSection'

export default {
  name: 'App',

  components: {
    CommentsSection,
    navigation,
    AppFooter,
    home,
    about,
    pricing,
    contact,
    BlogSection
  },

  data: () => ({
    fab: null,
    color: '',
    flat: null
  }),

  methods: {
    onScroll(e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 60
    },
    toTop() {
      this.$vuetify.goTo(0)
    }
  },

  created() {
    this.color = 'light-blue lighten-5'
    this.flat = false
  },
}
</script>

<style>
.pt-56 {
	padding-top: 56px;
}
/*.v-application ol, .v-application ul {*/
/*  padding-left: 12px;*/
/*}*/
</style>